import useIsMobile from 'hooks/use-is-mobile';
import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPreviewedSpotId } from 'store/spots/spots-actions';
import { SearchPageView } from 'utils/search-page-view';
import { useScrollToPreviewedSpot } from './use-scroll-to-previewed-spot';
import { useClearPreviewOnDesktopScroll } from './use-clear-preview-on-desktop-scroll';
export const useMapSideEffects = ({ mapWidgetRef, spots }) => {
    const prevPreviewedSpotId = useRef('');
    const isMobile = useIsMobile();
    const { previewedSpotId, mobileMapViewInteractionTrigger } = useSelector((state) => state.spots);
    const { view: searchPageView } = useSelector((state) => state.search.data);
    const dispatch = useDispatch();
    const scrollToPreviewedSpot = useScrollToPreviewedSpot({
        previewedSpotId,
        isMobile,
    });
    const shouldClearPreview = () => previewedSpotId && !spots.some(s => s.spotId === previewedSpotId);
    const clearPreview = useCallback(() => {
        dispatch(setPreviewedSpotId({ spotId: '' }));
    }, [dispatch]);
    useClearPreviewOnDesktopScroll({
        previewedSpotId,
        clearPreview,
        enabled: !isMobile && searchPageView === SearchPageView.DESKTOP_LIST,
    });
    useEffect(() => {
        if (!mapWidgetRef.current)
            return; // Map widget is not initialized yet
        const shouldSyncListWithMap = (isMobile && searchPageView === SearchPageView.MOBILE_MAP) ||
            (!isMobile && searchPageView === SearchPageView.DESKTOP_LIST);
        if (!shouldSyncListWithMap)
            return;
        if (shouldClearPreview()) {
            clearPreview();
            return;
        }
        // handle previewed spot id changes
        if (previewedSpotId &&
            prevPreviewedSpotId.current !== previewedSpotId) {
            const isMapInteraction = mobileMapViewInteractionTrigger === 'click' ||
                (isMobile && mobileMapViewInteractionTrigger === 'pan');
            if (isMapInteraction) {
                scrollToPreviewedSpot();
            }
            else if (isMobile &&
                mobileMapViewInteractionTrigger === 'scroll') {
                mapWidgetRef.current.panTo(previewedSpotId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        previewedSpotId,
        isMobile,
        mobileMapViewInteractionTrigger,
        spots,
        dispatch,
    ]);
};
